import { useState } from "react";
import { useAuth } from "../App";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";

/**
 * Diskretna značka za SA-način. Zamenjava za prejšnjo veliko rdečo pasico.
 * Prikaže majhen barvni SA znak (obarvan obrobek/dot), na klik pokaže ime LD in gumb za izhod.
 * Vsa dejanja v tem načinu se še vedno avdit-logirajo.
 */
export const ImpersonationBadge = () => {
  const { user, returnFromImpersonate } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!user?.impersonating) return null;

  const ldNaziv = user.ld_naziv || (typeof window !== "undefined" ? localStorage.getItem("ld_naziv") : "") || "LD";

  const handleReturn = async (e) => {
    e?.stopPropagation();
    const ok = await returnFromImpersonate();
    if (ok) navigate("/super-admin");
  };

  return (
    <div className="relative inline-flex" data-testid="sa-impersonation-badge">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className="inline-flex items-center justify-center h-5 w-5 rounded-full bg-amber-500/90 hover:bg-amber-500 text-white ring-2 ring-white shadow-sm transition"
        title={`SA-način: ${ldNaziv}`}
        aria-label="SA-način aktiven"
      >
        <ShieldAlert className="h-3 w-3" />
      </button>
      {open && (
        <div className="absolute top-6 left-0 z-[70] min-w-[220px] bg-white border border-amber-200 rounded-lg shadow-lg p-3 text-sm">
          <div className="flex items-start gap-2">
            <ShieldAlert className="h-4 w-4 text-amber-600 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <div className="font-semibold text-slate-900">SA-način</div>
              <div className="text-xs text-slate-600 mt-0.5">
                Upravljate kot predsednik <b>{ldNaziv}</b>. Dejanja se beležijo.
              </div>
            </div>
          </div>
          <button
            onClick={handleReturn}
            onMouseDown={(e) => e.preventDefault()}
            className="w-full mt-3 inline-flex items-center justify-center gap-1 bg-amber-600 hover:bg-amber-700 text-white text-xs font-medium px-2 py-1.5 rounded transition"
            data-testid="sa-impersonation-return-btn"
          >
            <LogOut className="h-3.5 w-3.5" />
            Vrni se v Super-admin
          </button>
        </div>
      )}
    </div>
  );
};

// Backwards-compatible default export (Layout imports ImpersonationBanner default)
export const ImpersonationBanner = () => null;
export default ImpersonationBanner;
